import { createServerOnlyFn } from "@tanstack/react-start";

import { initializeKitsWebConversation } from "./initialize-kits-web-conversation";
import { initializeKitsConversationInputSchema } from "./kits-conversation-session.contract";

const handleKitsWebConversation = createServerOnlyFn(
    async (request: Request) => {
        let json = {};
        const contentType = request.headers.get("content-type") ?? "";
        if (contentType.includes("application/json")) {
            try {
                json = await request.json();
            } catch {
                return Response.json(
                    { error: "Request body must be JSON." },
                    { status: 400 },
                );
            }
        }
        const parsed = initializeKitsConversationInputSchema.safeParse(json);
        if (!parsed.success) {
            return Response.json(
                { error: parsed.error.format() },
                { status: 400 },
            );
        }
        try {
            const session = await initializeKitsWebConversation(parsed.data);
            return Response.json(session);
        } catch (error) {
            return Response.json(
                {
                    error:
                        error instanceof Error
                            ? error.message
                            : "Failed to start a Kits web conversation.",
                },
                { status: 500 },
            );
        }
    },
);

export const kitsWebConversationsRoute = {
    server: {
        handlers: {
            POST: ({ request }: { request: Request }) =>
                handleKitsWebConversation(request),
        },
    },
};
